import { configureStore } from "@reduxjs/toolkit";

import common from "../features/admin/common/Slice";

//store
export const store = configureStore({
  reducer: {
    common: common,
  },
});
